import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer, { logout } from "./slices/userSlice";
import branchReducer from "./slices/branchSlice";
import departmentReducer from "./slices/departmentSlice";
import appointmentReducer from "./slices/appointmentSlice";
import { injectStore } from "../utils/api";

const appReducer = combineReducers({
  user: userReducer,
  branch: branchReducer,
  department: departmentReducer,
  appointment: appointmentReducer,
});

// Logout olduğunda tüm state'leri sıfırla
const rootReducer = (state, action) => {
  if (action.type === "user/logout") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

/** Logout yap ve tüm state'leri sıfırla (persist storage dahil) */
export const logoutAndReset = () => {
  store.dispatch(logout());
  persistor.purge();
};

// Axios instance'ına store ve logout fonksiyonunu ver
injectStore(store, { logoutAndReset });
